//export const front = process.env.REACT_APP_MSPORTAL_FRONT_URL || 'http://localhost:3000';
//export const back = process.env.REACT_APP_MSPORTAL_BACK_URL || 'http://localhost:8002';

export const front = 'https://msportal.macrosistemas.ar';
export const back = 'https://beportal.macrosistemas.ar';